export const UPLOAD_TAG_SHEET_STEPS_COUNT = 4;
